import { Color } from '@draughts/shared';

/**
 * «Ho appena mosso io?», per riaprire la proposta di patta.
 *
 * Il freno vive sul server, per posto, e dice «hai offerto: muovi prima di
 * riproporre». Lo SBLOCCO e' l'unica transizione che il server non ha occasione
 * di annunciare: `game:update` e' una trasmissione a tutta la stanza, mentre
 * questo stato e' di un posto solo. Quindi il client lo deriva.
 *
 * La regola, senza aritmetica sulle semimosse: un `game:update` arriva dopo
 * ogni mossa, e il tratto passa all'avversario SOLO dopo la mia. Se il tratto
 * ora e' suo, la mossa appena giocata e' mia. Non si sbaglia sulle prese
 * multiple (una mossa = un cambio di tratto) e non teme i rifai-mossa, che
 * invece manderebbero fuori strada qualunque conto sui ply.
 *
 * Il VERSO dell'errore e' scelto: se la derivazione sbaglia, sbaglia *aprendo*
 * il bottone — un gesto sprecato che torna indietro col motivo giusto. Un
 * evento privato dal server avrebbe il verso opposto: perso l'evento, bottone
 * spento per sempre. E' la morale del commit 4d09615b, dove la patta rimase
 * bloccata su «proposta inviata» per tutta la partita.
 *
 * Ritorna una toppa da spalmare nel `set` dello store, vuota quando non c'e'
 * niente da cambiare: cosi' chi la usa non fa un render in piu' per nulla.
 */
export function sbloccoPattaDopoMossa(
  turnoOra: Color | undefined,
  mioColore: 'white' | 'black' | null,
  drawMustMove: boolean,
): { drawMustMove: false } | Record<string, never> {
  if (!drawMustMove || !mioColore || !turnoOra) return {};
  /* `currentTurn` e' `Color` ('WHITE'/'BLACK'), `playerColor` e' 'white'/'black'. */
  const toccaAMe = turnoOra === (mioColore === 'white' ? Color.WHITE : Color.BLACK);
  return toccaAMe ? {} : { drawMustMove: false };
}
